// assets
import { IconBrandChrome, IconHelp, IconSitemap } from '@tabler/icons';

// constant
const icons = {
    IconBrandChrome: IconBrandChrome,
    IconHelp: IconHelp,
    IconSitemap: IconSitemap
};

//-----------------------|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||-----------------------//

export const other = {
    id: 'sample-docs-roadmap',
    type: 'group',
    children: [
        // {
        //     id: 'sample-page',
        //     title: 'Sample Page',
        //     type: 'item',
        //     url: '/sample-page',
        //     icon: icons['IconBrandChrome'],
        //     breadcrumbs: false
        // },
        {
            id: 'documentation',
            title: 'Documentação Online',
            type: 'item',
            url: 'https://loged.com.br',
            icon: icons['IconHelp'],
            external: true,
            target: true
        }
    ]
};
